import {useGLTranslation} from '../'

/**
 * Get options for performing a fetch with localized response info.
 *
 * @param contentType The type of content being sent to the endpoint. (optional)
 * @returns options for the fetch.
 */
export function useLocalizedFetchOptions(contentType?: string) {
  const {
    i18n: {language}
  } = useGLTranslation()
  const headers: HeadersInit = {
    'accept-language': language
  }
  if (contentType) {
    headers['Content-Type'] = contentType
  }
  return {
    headers
  }
}

export const clientPlatformWebHeader = {'client-platform': 'WEB'} as const
